/** Libellés FR/EN — progression, ceintures, examens Phase 1 */

export const PROGRESS_STATUSES = {
  en_progression: { fr: "En progression", en: "In progress" },
  a_pratiquer: { fr: "À pratiquer", en: "To practice" },
  presque_pret: { fr: "Presque prêt", en: "Almost ready" },
  recommande_examen: { fr: "Recommandé pour examen", en: "Recommended for exam" },
  examen_reussi: { fr: "Examen réussi", en: "Exam passed" },
  examen_a_reprendre: { fr: "Examen à reprendre", en: "Exam to retake" },
};

export const CRITERION_STATUSES = {
  non_commence: { fr: "Non commencé", en: "Not started" },
  en_cours: { fr: "En cours", en: "In progress" },
  maitrise: { fr: "Maîtrisé", en: "Mastered" },
  a_revoir: { fr: "À revoir", en: "To review" },
  a_pratiquer: { fr: "À pratiquer", en: "To practice" },
};

export const EXAM_STATUSES = {
  planifie: { fr: "Planifié", en: "Planned" },
  inscriptions_ouvertes: { fr: "Inscriptions ouvertes", en: "Registration open" },
  en_revision: { fr: "En révision", en: "Under review" },
  complete: { fr: "Complété", en: "Completed" },
  futur: { fr: "Futur", en: "Future" },
};

export const CRITERION_LABELS = {
  techniques: { fr: "Techniques de base", en: "Basic techniques" },
  kata: { fr: "Kata", en: "Kata" },
  kumite: { fr: "Kumite", en: "Kumite" },
  discipline: { fr: "Discipline / attitude", en: "Discipline / attitude" },
  presence: { fr: "Présence / assiduité", en: "Attendance" },
  examen: { fr: "Préparation examen", en: "Exam preparation" },
};

export const BELT_STATUS_LABELS = {
  actif: { fr: "Actif", en: "Active" },
  a_valider: { fr: "À valider", en: "To validate" },
  futur: { fr: "Futur", en: "Future" },
  inactif: { fr: "Inactif", en: "Inactive" },
};

/**
 * @param {Record<string, { fr: string, en: string }>} map
 * @param {string} key
 * @param {'fr'|'en'} locale
 */
export function progressLabel(map, key, locale = "fr") {
  const entry = map[key];
  if (!entry) return key;
  return locale === "en" ? entry.en : entry.fr;
}
